import { SystemConfigurationState } from './types'

export const state: SystemConfigurationState = {
  functionBlocks: [],
  functionBlockCategories: [],
  solutionHardwareDefinitions: [],
  solutionHardwareDefinitionCategories: [],
  globalVariables: [],
  packageInfo:[],
}